import React from 'react';

interface VerticalScreenHeaderProps {
  logo: string;
  title: string;
  titlePrefix?: string;
  backgroundColor?: string;
  textColor?: string;
  showDivider?: boolean;
}

function VerticalScreenHeader({
  logo,
  title,
  titlePrefix,
  backgroundColor = '#003DA5',
  textColor = '#fff',
  showDivider = true,
}: VerticalScreenHeaderProps) {
  return (
    <header
      className="relative p-[4vw]"
      style={{ backgroundColor, borderColor: backgroundColor }}
    >
      <div className="items-right flex items-center justify-between gap-[4vw]">
        <img
          src={logo}
          alt="Logo"
          className="max-h-[9.6vh] min-w-[30vw] max-w-[36vw] object-contain"
        />
        {showDivider && (
          <div
            className="h-[8vh] w-[0.5vw]"
            style={{ backgroundColor: '#fff' }}
          />
        )}
        <h2 className="text-[5vw]" style={{ color: textColor }}>
          {titlePrefix && <span className="font-normal">{titlePrefix} </span>}
          <span className="text-[7vw] font-bold">{title}</span>
        </h2>
      </div>
    </header>
  );
}

export default VerticalScreenHeader;
